<modal #modal>
    <div class="modal-header">
        <h5 class="modal-title">
            Ekstra sikkerhed ved handel på nettet
        </h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="close()">
            
        </button>
    </div>
    <div class="modal-body">
        Du kan ved køb af lodder opleve, at du skal igennem en ekstra sikkerheds godkendelse med en engangskode via sms eller via login med MitID. 
        Denne sikkerhedsgodkendelse er en international indsats mod misbrug.
        <button type="button" class="btn btn-green" aria-label="Close" (click)="close()">
            Ok
        </button>
    </div>
</modal>
